import React, { useCallback, useRef } from 'react'
import { CustomInput } from 'reactstrap'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { useLocalization } from '@/hooks/localization'
import uuid from 'uuid'

const CheckBox = ({ id, checked, value, label, title, onChange, disabled, ...rest }) => {
  const { localize } = useLocalization()
  const idRef = useRef(id || `chb_${uuid()}`)
  const handleChange = useCallback(e => {
    onChange(e.target.checked === true, value)
  }, [onChange, value])
  const finalLabel = label || (title && localize(title)) || '\u00A0'
  return (
    <CustomInput
      {...rest}
      type='checkbox' id={idRef.current} checked={checked || false} disabled={disabled || false} value={value || ''} label={finalLabel}
      onChange={handleChange} />
  )
}

function CheckBoxRow ({ id, label, checked, onChange }) {
  return (
    <InfoRow>
      <InfoLabel>&nbsp;</InfoLabel>
      <InfoContent>
        <CheckBox
          id={id} label={label}
          value={checked || false}
          onChange={onChange} />
      </InfoContent>
    </InfoRow>
  )
}

export default CheckBox
export {
  CheckBox,
  CheckBoxRow
}



// WEBPACK FOOTER //
// ./src/components/CheckBox.js